module.exports = __webpack_public_path__ + "img/enterpriseWechat.977978fe.png";